import { type WorkflowToolComponentProps } from '../shared/WorkflowToolComponent'

export function WordPressGetPageDisplay({ nodeExecution }: WorkflowToolComponentProps) {
  const result = nodeExecution.outputs

  if (!result || !result.success) {
    return null
  }

  const data = result.result

  let markdown = '## WordPress Page Retrieved\n\n'
  markdown += `**Title:** ${data.title}\n\n`
  markdown += `**URL:** [${data.url}](${data.url})\n\n`
  markdown += `**Status:** ${data.status}\n\n`
  markdown += `**Slug:** ${data.slug}\n\n`

  if (data.excerpt) {
    markdown += `**Excerpt:** ${data.excerpt}\n\n`
  }

  if (data.modified) {
    markdown += `**Last Modified:** ${new Date(data.modified).toLocaleString()}\n\n`
  }

  if (data.content?.rendered) {
    const contentLength = data.content.rendered.length
    markdown += `**Content Length:** ${contentLength} characters\n\n`
  }

  return markdown
}
